import { render, staticRenderFns } from "./callModal.vue?vue&type=template&id=ef0c5498"
import script from "./callModal.vue?vue&type=script&lang=js"
export * from "./callModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports